import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { toast } from 'sonner';
import { APIError, api } from '@/lib/api';
import { AuthForm } from './AuthForm';
import { AuthShell } from './AuthShell';
import { validateEmail } from './validation';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | undefined>();
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  async function submit() {
    const emailError = validateEmail(email);
    if (emailError) {
      setError(emailError);
      return;
    }
    setSubmitting(true);
    try {
      const res = await api.auth.forgotPassword(email.trim());
      toast.success(res.message);
      setSent(true);
    } catch (err) {
      toast.error(err instanceof APIError ? err.detail : 'Something went wrong');
    } finally {
      setSubmitting(false);
    }
  }

  if (sent) {
    return (
      <AuthShell title="Check your inbox" subtitle="">
        <p className="text-center text-sm text-muted-foreground">
          If <span className="font-medium text-foreground">{email.trim()}</span> is registered,
          a password reset link is on its way. The link expires in 30 minutes.
        </p>
        <div className="mt-6 text-center text-sm text-muted-foreground">
          <Link to="/login" className="font-medium text-foreground hover:underline">
            Back to login
          </Link>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthForm
      title="Forgot password?"
      subtitle="Enter your email and we'll send a reset link"
      submitLabel="Send reset link"
      submitting={submitting}
      onSubmit={submit}
      fields={[
        {
          id: 'email',
          label: 'Email',
          type: 'email',
          value: email,
          onChange: (v) => {
            setEmail(v);
            setError(undefined);
          },
          autoComplete: 'email',
          placeholder: 'you@example.com',
          error,
          required: true,
        },
      ]}
      footer={
        <Link to="/login" className="font-medium text-foreground hover:underline">
          Back to login
        </Link>
      }
    />
  );
}
